import { Grid, Typography, useMediaQuery } from "@mui/material";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import Color from "../../../assets/colors";
import useTriggerSnackbar from "../../../hooks/useTriggerSnackbar";
import {
  updateContactUsEmployer,
  updateViewProductEmployer,
} from "../../../redux/actions/dialog_action";
import EmployerLandingProduct from "../EmployerLandingProduct/EmployerLandingProduct";
import {
  BoxContainer,
  ButtonStyled,
  CardContainer,
  CloseButton,
  CloseIcon,
  DialogContainer,
  InnerScrollContainer,
  ScrollContainer,
  ScrollTextContainer,
  TextStyled,
} from "./styles";
import { useEffect, useRef } from "react";

function EmployerLandingViewProductDialog(props) {
  const isDesktop = useMediaQuery("(min-width:1280px)");
  const isTablet = useMediaQuery("(min-width:640px)");

  const router = useRouter();
  const dispatch = useDispatch();
  const ref = useRef(null);
  const [triggerSnackbarFunc] = useTriggerSnackbar();

  const visible = useSelector(
    (state) => state?.dialog?.showViewProductEmployerDialog
  );

  const contactUs = useSelector(
    (state) => state?.dialog?.showContactUsEmployerDialog
  );

  function handleClose() {
    dispatch(updateViewProductEmployer(false));
  }

  function handleContactUs() {
    dispatch(updateContactUsEmployer({ state: true }));
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        handleClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  return (
    <DialogContainer open={visible?.state ? visible?.state : visible}>
      <CardContainer ref={ref}>
        {!isDesktop && (
          <BoxContainer
            flexDirection={"row"}
            position={"sticky"}
            top={"0px"}
            backgroundColor={"white"}
            padding={"1rem 1rem 1rem 1rem"}
            justifyContent={"space-between"}
            borderBottom={"1px solid" + Color.grey}
          >
            <TextStyled
              fontSize={"24px"}
              fontWeight={600}
              lineHeight={"26.4px"}
            >
              Job Ads Made{" "}
              <span style={{ color: Color?.hiredlyPurple }}>Simple</span>
            </TextStyled>
            <CloseButton onClick={handleClose}>
              <CloseIcon />
            </CloseButton>
          </BoxContainer>
        )}

        {isDesktop ? (
          <ScrollContainer flexDirection={"column"}>
            <InnerScrollContainer flexDirection={"column"} overflow={"scroll"}>
              <EmployerLandingProduct />
            </InnerScrollContainer>
            <ScrollTextContainer backgroundColor={"white"}>
              <TextStyled
                fontSize={"16px"}
                fontWeight={"600"}
                color={"#AEAEAE"}
              >
                Scroll to view more
              </TextStyled>
            </ScrollTextContainer>
          </ScrollContainer>
        ) : (
          <InnerScrollContainer flexDirection={"column"}>
            <EmployerLandingProduct />
          </InnerScrollContainer>
        )}

        {!isDesktop && (
          <BoxContainer
            flexDirection={"column"}
            backgroundColor={"white"}
            position={"sticky"}
            bottom={"0px"}
            justifyContent={"center"}
          >
            <ScrollTextContainer backgroundColor={"white"}>
              <TextStyled
                fontSize={"16px"}
                fontWeight={"600"}
                color={"#AEAEAE"}
              >
                Scroll to view more
              </TextStyled>
            </ScrollTextContainer>
            <Grid
              borderTop={"1px solid" + Color.grey}
              sx={{
                display: "flex",
                justifyContent: "center",
                padding: "16px 0px",
              }}
            >
              <ButtonStyled onClick={handleContactUs}>Contact Us</ButtonStyled>
            </Grid>
          </BoxContainer>
        )}
      </CardContainer>
    </DialogContainer>
  );
}

export default EmployerLandingViewProductDialog;
